import { render, staticRenderFns } from "./JDSku.vue?vue&type=template&id=019a674a&scoped=true&"
import script from "./JDSku.vue?vue&type=script&lang=js&"
export * from "./JDSku.vue?vue&type=script&lang=js&"
import style0 from "./JDSku.vue?vue&type=style&index=0&id=019a674a&prod&lang=stylus&scoped=true&"
import style1 from "./JDSku.vue?vue&type=style&index=1&id=019a674a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "019a674a",
  null
  
)

export default component.exports